import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FurySharedModule } from 'src/@fury/fury-shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NgxPaginationModule } from 'ngx-pagination';
import { MatOptionModule } from '@angular/material/core';
import { ListModule } from 'src/@fury/shared/list/list.module';
import { MatDialogModule } from '@angular/material/dialog';
import { NgxMaskModule } from 'ngx-mask';

import { CustomerServiceAgreementRoutingModule } from './customer-service-agreement-routing.module';
import { CustomerServiceAgreementComponent } from './customer-service-agreement.component';
import { CustomerServiceAgreementListComponent } from './customer-service-agreement-list/customer-service-agreement-list.component';
import { UploadeServiceAgreementComponent } from './uploade-service-agreement/uploade-service-agreement.component';
import { ViewCustomerServiceAgreementComponent } from './view-customer-service-agreement/view-customer-service-agreement.component';
import { SharedModule } from 'src/app/shared/shared.module';


@NgModule({
  declarations: [
    CustomerServiceAgreementComponent,
    CustomerServiceAgreementListComponent,
    UploadeServiceAgreementComponent,
    ViewCustomerServiceAgreementComponent
  ],
  imports: [
    CommonModule,
    CustomerServiceAgreementRoutingModule,
    FurySharedModule,
    ReactiveFormsModule,
    FormsModule,
    MatSelectModule,
    MatChipsModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    NgxPaginationModule,
    MatCheckboxModule,
    MatIconModule,
    MatOptionModule,
    ListModule,
    NgxMaskModule,
    MatDialogModule,
    SharedModule
  ]
})
export class CustomerServiceAgreementModule { }
